"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class ContentImportProductStore {
    constructor() {
        this.products = [];
        this.selectedMarketplaceId = null;
        this.selectedProductTime = 0;
        this.getImportTimeInSeconds = () => {
            return Math.floor((new Date().getTime() - this.selectedProductTime) / 1000);
        };
    }
    get selectedProduct() {
        return this.products.find((item) => item.marketplaceId === this.selectedMarketplaceId);
    }
    setProducts(products) {
        this.products = products;
    }
    setSelectedMarketplaceId(marketplaceId) {
        this.selectedMarketplaceId = marketplaceId;
        this.selectedProductTime = new Date().getTime();
    }
    clear() {
        this.selectedMarketplaceId = null;
        this.selectedProductTime = 0;
    }
}
__decorate([
    mobx_1.observable
], ContentImportProductStore.prototype, "products", void 0);
__decorate([
    mobx_1.observable
], ContentImportProductStore.prototype, "selectedMarketplaceId", void 0);
__decorate([
    mobx_1.computed
], ContentImportProductStore.prototype, "selectedProduct", null);
__decorate([
    mobx_1.action
], ContentImportProductStore.prototype, "setProducts", null);
__decorate([
    mobx_1.action
], ContentImportProductStore.prototype, "setSelectedMarketplaceId", null);
__decorate([
    mobx_1.action
], ContentImportProductStore.prototype, "clear", null);
exports.default = new ContentImportProductStore();
